<style scoped lang="scss">
@import '~guest-variables';

.grid {
    margin-right: -30px;
}
/* clear fix */
.grid:after {
  content: '';
  display: block;
  clear: both;
}

.grid-item {
  float: left;
}

.spinner_wrapper {
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
}

</style>
<style lang="scss">
    .spinner-backdrop {
        background: none !important;
    }
</style>
<template>
    <div>
        <form v-if="!showSuccess && model" @submit.prevent="store">

            <div class="form-group">
                <label for="name">Naam:</label>
                <input type="text" class="form-control" :disabled="this.pageSpinner && this.pageSpinner.isActive" id="name" v-model.trim="$v.model.name.$model">
                <div class="invalid-feedback" v-has-error="'name'">
                    Dit veld is verplicht.
                </div>
            </div>
            <div class="form-group">
                <label for="email">E-mailadres:</label>
                <input type="text" class="form-control" :disabled="this.pageSpinner && this.pageSpinner.isActive" id="email" v-model.trim="$v.model.email.$model">
                <div class="invalid-feedback" v-has-error="'email'">
                    Dit is geen geldig e-mailadres.
                </div>
            </div>
            <div class="form-group">
                <label for="msg">Bericht:</label>
                <textarea class="form-control" id="msg" :disabled="this.pageSpinner && this.pageSpinner.isActive" v-model.trim="$v.model.msg.$model"></textarea>
                <div class="invalid-feedback" v-has-error="'msg'">
                    Dit veld is verplicht.
                </div>
            </div>
            <div class="form-group">
                <label for="captcha">{{ d1 }} + {{ d2 }} is:</label>
                <input type="text" class="form-control" id="captcha" :disabled="this.pageSpinner && this.pageSpinner.isActive" v-model.trim="$v.model.captcha.$model">
                <div class="invalid-feedback" v-has-error="'captcha:required'">
                    Dit veld is verplicht.
                </div>
                <div class="invalid-feedback" v-has-error="'captcha:numeric'">
                    Vul een cijfer in.
                </div>
                <div class="invalid-feedback" v-if="error === ' '">
                    De opgegeven uitkomst is niet correct.
                </div>
            </div>

            <div class="form-group">
                <div class="d-flex align-items-center">
                    <button type="submit" :disabled="this.pageSpinner && this.pageSpinner.isActive" class="btn btn-primary">
                        Verstuur
                    </button>
                    <div class="spinner_wrapper ml-2">
                        <spinner class="pageSpinner" @initized="pageSpinner = $event; $emit('pageSpinner');" :size="24"></spinner>
                    </div>
                    <div v-if="error" class="invalid-feedback ml-2">
                        Oeps! Er is iets mis gegaan{{ error }}
                    </div>
                </div>
            </div>

        </form>
        <div v-if="showSuccess">
            Bedankt voor uw bericht!<br>
            Wij nemen zo spoedig mogelijk contact met u op.
        </div>
    </div>
</template>

<script>
    import { required, email, numeric } from 'vuelidate/lib/validators';
    import Vuelidate from 'vuelidate';
    Vue.use(Vuelidate);

    export default {

        props: {
            d1: String,
            d2: String,
        },

        data() {
            return {
                pageSpinner: null,
                isSubmitted: false,
                showSpinner: false,
                showSuccess: false,
                error: null,
                model: {
                    name: '',
                    email: '',
                    msg: '',
                    captcha: '',
                },
            };
        },

        validations: {
            model: {
                name: {
                    required,
                },
                email: {
                    required,
                    email,
                },
                msg: {
                    required,
                },
                captcha: {
                    required,
                    numeric,
                },
            }
        },

        methods: {

            store() {
                this.isSubmitted = true
                this.error = null;

                if (!this.$v.model.$pending && !this.$v.model.$invalid) {

                    this.pageSpinner.spin(axios.post('/dynamic/contact', this.model))
                        .then(response => {
                            this.showSuccess = true;
                        })
                        .catch(error => {
                            if (error.toString().indexOf('422') > -1) {
                                this.error = ' ';
                            } else {
                                this.error = ': ' +  error;
                            }
                        });
                }
            },

        },

    }
</script>
